import { render, staticRenderFns } from "./Reviewdatails.vue?vue&type=template&id=2ffe308a&scoped=true"
import script from "./Reviewdatails.vue?vue&type=script&lang=js"
export * from "./Reviewdatails.vue?vue&type=script&lang=js"
import style0 from "./Reviewdatails.vue?vue&type=style&index=0&id=2ffe308a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe308a",
  null
  
)

export default component.exports